export default {
  title: 'Votre avis nous aide vraiment ❤️',
  description: '{{name}} sur le {{store}} — appuyez simplement sur une étoile',
  buttons: {
    not_now: 'Pas maintenant',
    continue: 'Continuer',
  },
};
